import { fromEvent, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

const SIZE_TOLERANCE_IN_PERCENT = 30;

export class ImageUtils {
  static isSquare(imageSrc: string): Observable<boolean> {
    const image = new Image();
    const mapLoadedImage = (event): boolean => ImageUtils.withinTolerance(event.target.width, event.target.height);
    const $loadedImg = fromEvent(image, 'load').pipe(take(1), map(mapLoadedImage));
    image.src = imageSrc;

    return $loadedImg;
  }

  static withinTolerance(width: number, height: number): boolean {
    const difference = Math.abs(width - height);
    const percentDifference = (difference / ((width + height) / 2)) * 100;

    return percentDifference < SIZE_TOLERANCE_IN_PERCENT;
  }
}
